import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '../Button/Button';
import TextField from '@mui/material/TextField';
import style from './Modal.scss'

export default function Modal(props){

    return (
        <Dialog open={props.open} onClose={props.onClose} sx={{"box-shadow": "0px 8px 16px rgba(59, 75, 82, 0.15), 0px 0px 4px rgba(59, 75, 82, 0.05)", "border-radius": "16px" , "padding": "24px"}}>
        <DialogTitle>{props.title} </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {props.text}
          </DialogContentText>
          {props.textField && <TextField
            autoFocus
            margin="dense"
            id={props.textFieldLabel}
            label={props.textFieldLabel}
            type={props.textFieldLabel}
            fullWidth
            variant="standard"
            onChange={(event) => props.textFieldSetText(event.target.value) }
          />
          }
          {props.textField2 && <TextField
            autoFocus
            margin="dense"
            id={props.textFieldLabel2}
            label={props.textFieldLabel2}
            type={props.textFieldLabel2}
            fullWidth
            variant="standard"
            onChange={(event) => props.textFieldSetText2(event.target.value) }
          />
          }
        </DialogContent>
        <DialogActions>
           {props.buttons && props.buttons[0] && <Button style={props.buttons[0].style} onClick={props.buttons[0].onClick} text={props.buttons[0].text} disabled={props.buttons[0].disabled} className={props.buttons[0].class}/>} 
           {props.buttons && props.buttons[1] && <Button style={props.buttons[1].style} onClick={props.buttons[1].onClick} text={props.buttons[1].text} disabled={props.buttons[1].disabled} className={props.buttons[1].class}/>}
        </DialogActions>
      </Dialog>
    )
}